/* eslint-disable */

import { httpMethods } from 'enums';
import { Http } from 'library';
import api from '../../../api/client';
import * as Endpoints from '../../../constants/endpoints.constant';;

class BuyCoinsBarsServices {
  async getAllProducts() {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(Endpoints.GET_ALL_PRODUCTS)
      .setToken(api.getToken())
      .request();
  }

  async getSingleProduct(itemCode) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_SINGLE_PRODUCT}/${itemCode}`)
      .setToken(api.getToken())
      .request();
  }

  async addDeliveryAddress(data: any, customerId: any) {
    const newData = { ...data, customerId: customerId };
    return await Http.setMethod(httpMethods.post)
      .setData(newData)
      .setUrl(Endpoints.ADD_ADDRESS)
      .setToken(api.getToken())
      .request();
  }
  async updateDeliveryAddress(data: any, addressId: any) {
    return await Http.setMethod(httpMethods.patch)
      .setData(data)
      .setUrl(`${Endpoints.UPDATE_ADDRESS}/${addressId}`)
      .setToken(api.getToken())
      .request();
  }

    async updateBillingAddress(data: any) {
    return await Http.setMethod(httpMethods.patch)
      .setData(data)
      .setUrl(`${Endpoints.UPDATE_BILLING_ADDRESS}`)
      .setToken(api.getToken())
      .request();
  }


  async deleteDeliveryAddress(addressId: any) {
    return await Http.setMethod(httpMethods.delete)
      .unsetData()
      .setUrl(`${Endpoints.DELETE_ADDRESS}/${addressId}`)
      .setToken(api.getToken())
      .request();
  }

  async getDeliveryAddress(customerId: any) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_ADDRESS}?customerId=${customerId}`)
      .setToken(api.getToken())
      .request();
  }

  async checkBillingAddress(){
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.CHECK_BILLING_ADDRESS}`)
      .setToken(api.getToken())
      .request();
  }

  async checkIfPincodeIsServiceable(pincode: string) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.CHECK_PINCODE_SERVICE}/${pincode}`)
      .request();
  }

  async addProductToCart(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.ADD_TO_CART}`)
      .setToken(api.getToken())
      .request();
  }

  async getProductCartSummery(userId: any) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_CART_SUMMERY}?userId=${userId}`)
      .setToken(api.getToken())
      .request();
  }
  async deliveryOrder(data: any) {
    return await Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.DELIVERY_ORDER}`)
      .setToken(api.getToken())
      .request();
  }

  async checkPaymentLimit(){
     return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.PAYMENT_LIMIT}`)
      .setToken(api.getToken())
      .request();
  }
  async getFaqs(){
return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.FAQS}`)
      .setToken(api.getToken())
      .request();
  }
}

export default new BuyCoinsBarsServices();
